import { throttle } from 'lodash-es'
import axios from 'axios';
import { setAuthCookie, getAuthCookie, removeAuthCookie } from 'src/utils/cookies'

interface HttpError extends Error {
  statusCode?: number
  errors?: Record<string, string[] | string>
}

const refreshToken = throttle(async () => {
  try {
    const auth = JSON.parse(getAuthCookie() || '{}')
    const result = await axios.post(
      '/api/refresh',
      {},
      {
        headers: {
          authorization: `Bearer ${auth.refresh_token}`,
        },
      }
    )
    setAuthCookie(JSON.stringify({
      ...auth,
      access_token: result.data.access_token,
      refresh_token: result.data.refresh_token,
    }))
    return result
  } catch (error) {
    removeAuthCookie()
  }
}, 10000)

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use(
  async (config) => {
    const auth = JSON.parse(getAuthCookie() || '{}')
    if (auth.access_token) {
      config.headers.Authorization = `Bearer ${auth.access_token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config

    if (error?.response?.status === 401 && !config?.sent) {
      config.sent = true
      const result = await refreshToken()

      if (result?.data.access_token) {
        config.headers['authorization'] = `Bearer ${result?.data.access_token}`
      }
      return axios(config)
    }
    const customError: HttpError = {
      ...error,
      message: error.response?.data?.message,
      statusCode: error.response?.status,
    }
    return Promise.reject(customError)
  }
)

export default axiosInstance
